import React from "react";
import { Row, Col } from "antd";
import { Metrics } from "../../theme/index";
import OCard from "../card/index";
import Colors from "../../theme/Colors";
import NumberUtil from "../../util/number";
import { withTheme } from "styled-components";
import { ThemeHelper } from "../../hoc/with/withThemeProvider";

const SessionBox = ({
	color,
	fontSize = Metrics.fontSize.focusContent,
	textFontSize = Metrics.fontSize.content,
	fontWeight = Metrics.heavyFontWeidht,
	ligthFontColor = Colors.lightFontColor,
	lightFontWeight = Metrics.lightFontWeight,
	text,
	value,
	session,
	cardStyle,
	innerStyle
}) => (
	<OCard.LightCard style={cardStyle}>
		<Row type="flex" align="middle" style={innerStyle}>
			<Col span={12}>
				<Row>
					<Col span={24}>
						{" "}
						<label style={{ color: color, fontSize: fontSize, fontWeight }}>
							{value < 100000 ? value : NumberUtil.numberToUnit(value)}
						</label>
					</Col>
					<Col span={24}>
						<label style={{ color: "red", fontSize: 13, fontWeight }}>
							{session < 100000 ? session : NumberUtil.numberToUnit(session)}{" "}
								Session{session > 1? "s": ""}
						</label>
					</Col>
				</Row>
			</Col>
			<Col span={12} style={{ color: ligthFontColor, fontSize: textFontSize }}>
				{text}
			</Col>
		</Row>
	</OCard.LightCard>
);
export const VisualSessionBox = withTheme(props => (
	<SessionBox
		{...props}
		color={ThemeHelper.getMainVisualizeColor(props, 0, props.visualColorKey)}
	/>
));
export const ThemeSessionBox = withTheme(props => (
	<SessionBox {...props} color={props.colorType} />
));
export default SessionBox;



// WEBPACK FOOTER //
// ./src/components/form/SessionBox.js